module.exports = __webpack_public_path__ + "img/tong.80fafc0f.png";